import { AsyncStoreItem } from '@lib';
import { PostSeatmapResponse } from 'src/sdk_checkin';

/**
 * SeatmapResult model
 */
export interface SeatmapResultModel {
  model: PostSeatmapResponse | null;
}

/**
 * PostSeatmapResponse model details
 */
export interface SeatmapResultStateDetails extends AsyncStoreItem {}

/**
 * SeatmapResult store state
 */
export interface SeatmapResultState extends SeatmapResultStateDetails, SeatmapResultModel {}

/**
 * Name of the SeatmapResult Store
 */
export const SEATMAP_RESULT_STORE_NAME = 'seatmapResult';

/**
 * SeatmapResult Store Interface
 */
export interface SeatmapResultStore {
  /** SeatmapResult state */
  [SEATMAP_RESULT_STORE_NAME]: SeatmapResultState;
}
